import { api } from './BaseApi'
import {
  IValueTypeDimensionRequest,
  IValueTypeDimensionResponse,
} from './dto/ValueTypeDimensionDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const valueTypeDimensionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getValueTypeDimensionList: builder.query<
      IValueTypeDimensionResponse,
      IValueTypeDimensionRequest
    >({
      query: (params) => ({
        url: `/value_type_dimension/get_value_type_dimensions/${createQueryStringSmart(params)}`,
      }),
    }),
  }),
})

export const { useGetValueTypeDimensionListQuery } = valueTypeDimensionApi
